import styled from 'styled-components'

export const ReviewAndLaunchWrapper = styled.div``
